import { Country } from '@shared-models';

import { ICountry } from 'src/app/@interfaces/country.interface';

export class CountryMapper {
  static mapper(country: ICountry[] | ICountry): Country {
    const countryObject = Array.isArray(country) ? country[0] : country;
    return {
      id_country: countryObject.id_country?.toString(),
      name: countryObject.name,
      iso: countryObject.iso!,
      iso_alpha_2: countryObject.iso_alpha_2!,
      iso_num: countryObject.iso_num!,
      phone_code: countryObject.phone_code!,
    };
  }
}
